import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue")
  },
  {
    path: "/users",
    name: "Users",
    component: () => import("../views/ManageUsers.vue")
  },
  {
    path: "/sites",
    name: "Sites",
    component: () => import("../views/ManageSites.vue")
  },
  {
    path: "/generator",
    name: "Generator",
    component: () => import("../views/Generate.vue")
  },
  {
    path: "/forgotpassword",
    name: "ForgotPassword",
    component: () => import("../views/ForgotPassword.vue")
  },
  {
    path: "/resetpassword",
    name: "ResetPassword",
    component: () => import("../views/ResetPassword.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue")
  },
  {
    path: "/installers",
    name: "Installers",
    component: () => import("../views/ManageInstallers.vue")
  },
  {
    path: "/installer/:id",
    name: "InstallerDetails",
    component: () => import("../views/InstallerDetails.vue")
  }
];

const router = new VueRouter({
  routes
});

export default router;
